export { useResourceConfig } from './useResourceConfig';

